import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { EncryptionService } from '../Encryption/encryption.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  orgId: string = null;
  constructor(
    private router: Router,
    private encryptionService: EncryptionService
  ) {
    if (localStorage.getItem('UserDetails') != null) {
      const decryptedUserData = this.encryptionService.decrypt(
        localStorage.getItem('UserDetails')
      );
      this.orgId = decryptedUserData.OrganizationID;
    } else {
      this.orgId = null;
    }
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.orgId == null) {
      if (localStorage.getItem('UserDetails') != null) {
        const decryptedUserData = this.encryptionService.decrypt(
          localStorage.getItem('UserDetails')
        );
        this.orgId = decryptedUserData.OrganizationID;
      } else {
        this.orgId = null;
      }
    }
    let isUserLoggedIn = this.orgId ? true : false;
    if (isUserLoggedIn) {
      return true; // Continue with the navigation
    } else {
      // Navigate to the authentication page
      return this.router.parseUrl('/authentication/login'); // Adjust the path as needed
    }
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return true;
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return true;
  }
  canMatch(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return true;
  }
}
